<template>
  <div class="jump-item">
    <el-link type="primary" @click.native="jumpToBreak(source)">
      {{ source.transactionId }} —
      {{ $dayjs(source.createdAt).format("DD.MM.YYYY HH:mm:ss") }}
    </el-link>
    (ожидалось {{ source.expected }}, записано {{ source.actual }}, разница
    {{ source.diff }})
    <span v-if="source.isFirstTransaction" class="first-tx-note">
      — это первая проводка счёта, сравнивать не с чем: похоже, начальный
      баланс счёта задали напрямую, в обход проводок
    </span>
  </div>
</template>
<script>
export default {
  name: "FullBalanceBreakItem",
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object,
      required: true
    },
    jumpToBreak: {
      type: Function,
      default: () => {}
    }
  }
};
</script>
<style scoped>
.jump-item {
  padding: 4px 0;
}
.first-tx-note {
  color: #909399;
  font-size: 0.85rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/FullBalance/BreakItem.vue